export default {
  SET_BLOCKCHAIN(state, payload) {
    state.blockchain = payload
  },
  SET_BLOCKCHAIN_USER_SELECTED(state, payload) {
    state.blockchainUserSelected = payload
  },
  SET_BLOCKCHAIN_ERROR(state, payload) {
    state.blockchainError = payload
  },
  SET_BLOCKCHAIN_INPUT(state, payload) {
    state.blockchainInput = payload
  },
  SET_BLOCKCHAIN_INFO(state, payload) {
    state.blockchainInfo = payload
  },
  SET_BLOCKCHAIN_RESPONSE(state, payload) {
    state.blockchainResponse = payload
  },
  SET_BLOCKCHAIN_DROPDOWN(state, payload) {
    state.blockchainDropdown = {
      ...state.blockchainDropdown,
      ...payload
    }
  },
  RESET_BLOCKCHAIN_DROPDOWN(state) {
    Object.keys(state.blockchainDropdown).forEach(key => {
      state.blockchainDropdown[key] = false
    })
  },
  SET_BLOCKCHAIN_REQUESTS_OPEN(state, payload) {
    state.blockchainRequestsOpen = payload
  },
  SET_BLOCKCHAIN_RECENT_QUERIES_STATE(state, payload) {
    state.blockchainRecentQueriesState = payload
  },
}
